import type { CartItem } from 'types'
import { getShopUrl } from './get-shop-url'

export const mapCartProducts = (cartItems: CartItem[]) => {
  return cartItems.map((cartItem: CartItem) => ({
    category: cartItem.product_type || 'Fragrance',
    brand: cartItem.vendor,
    url: `https://${getShopUrl()}/products/${cartItem.handle}`,
    product_id: cartItem.product_id.toString(),
    sku: cartItem.sku,
    name: cartItem.product_title,
    price: cartItem.price / 100,
    variant: cartItem.variant_options?.[0] || 'Default Title',
    quantity: cartItem.quantity,
    shopify_product_id: cartItem.product_id.toString(),
    shopify_variant_id: cartItem.variant_id.toString(),
    presentment_amount: (cartItem.price / 100).toFixed(2),
    presentment_currency: 'USD',
    image_url: cartItem.image,
  }))
}
